// az email-ben küldött jelszó váltás oldala

import { useState, useMemo } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import PasswordInput from '../components/PasswordInput';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    // hiba az új jelszó kérés során
    if (!token) {
      setError('Hiányzó vagy érvénytelen reset token. Kérj új jelszó-helyreállítási linket.');
      setLoading(false);
      return;
    }
    // jelszó hossz ellenőrzés
    if (formData.password.length < 6) {
      setError('A jelszó legalább 6 karakter hosszú kell legyen.');
      setLoading(false);
      return;
    }
    // a jelszó megerősítő nem egyezik meg
    if (formData.password !== formData.confirmPassword) {
      setError('A két jelszó nem egyezik meg.');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password: formData.password })
      });

      const data = await response.json();
      // sikeres változtatás
      if (!response.ok || !data.success) {
        setError(data.message || 'A jelszó frissítése sikertelen.');
        return;
      }

      setMessage(data.message || 'A jelszó sikeresen frissítve.');
      setFormData({ password: '', confirmPassword: '' });

      setTimeout(() => navigate('/bejelentkezes'), 1800);
    } catch (err) {
      setError('Hálózati hiba történt. Próbáld meg újra.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-transparent font-sans transition-colors">
      <div className="max-w-md w-full bg-transparent rounded-[2.5rem] shadow-none p-5 sm:p-10 border border-transparent">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-black text-gray-900 dark:text-white tracking-tighter uppercase">
            Új jelszó
          </h1>
        </div>

        {/* A hiba és sikerüzenet csak akkor jelenik meg, ha van megjelenítendő szöveg. */}
        {error && (
          <div className="mb-6 p-4 bg-rose-50 dark:bg-rose-900/30 border-l-4 border-rose-500 dark:border-rose-700 rounded-xl text-rose-700 dark:text-rose-400 text-sm font-bold">
            ⚠️ {error}
          </div>
        )}

        {message && (
          <div className="mb-6 p-4 bg-emerald-50 dark:bg-emerald-900/30 border-l-4 border-emerald-500 dark:border-emerald-700 rounded-xl text-emerald-700 dark:text-emerald-300 text-sm font-bold">
            ✅ {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-[10px] font-black text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-2 ml-1">
              Új jelszó
            </label>
            <PasswordInput
              required
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className="w-full p-4 bg-gray-50 dark:bg-gray-700 border-2 border-gray-100 dark:border-gray-600 rounded-2xl focus:border-blue-500 dark:focus:border-blue-400 outline-none font-bold transition-all dark:text-white"
              placeholder="Új jelszó"
            />
          </div>

          <div>
            <label className="block text-[10px] font-black text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-2 ml-1">
              Jelszó megerősítése
            </label>
            <PasswordInput
              required
              value={formData.confirmPassword}
              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              className="w-full p-4 bg-gray-50 dark:bg-gray-700 border-2 border-gray-100 dark:border-gray-600 rounded-2xl focus:border-blue-500 dark:focus:border-blue-400 outline-none font-bold transition-all dark:text-white"
              placeholder="Új jelszó ismét"
            />
          </div>

          <button
            type="submit"
            disabled={loading || !token}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-5 rounded-2xl font-black uppercase tracking-widest shadow-xl hover:shadow-2xl transition-all active:scale-95 disabled:opacity-50 mt-4"
          >
            {loading ? 'Frissítés...' : 'Jelszó mentése'}
          </button>
        </form>


         {/* A link lehetővé teszi a bejelentkezési oldalra való visszatérést. */}
        <div className="mt-8 text-center">
          <Link to="/bejelentkezes" className="text-sm font-medium text-blue-600/80 dark:text-blue-300/90 hover:text-blue-700 dark:hover:text-blue-200 hover:underline transition-all">
            Vissza a bejelentkezéshez
          </Link>
        </div>
      </div>
    </div>
  );
}